import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
})
export class CheckboxComponent implements OnInit, OnChanges {
  @Input() id!: string;
  @Input() label: string = '';
  @Input() value: any;
  @Input() checked: boolean = false;
  @Input() disabled: boolean = false;
  @Input() selectedCategories: [] = [];
  /** FormControl from the parent; typed as `any` because callers use `form.get()`. */
  @Input() control!: any;
  @Input() fontSize: string = '';

  @Output() sendClick = new EventEmitter();

  ngOnInit(): void {
    this.syncDisabledWithControl();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled'] || changes['control']) {
      this.syncDisabledWithControl();
    }
  }

  /** Reactive forms ignore `[disabled]` on the element; sync via the control instead. */
  private syncDisabledWithControl(): void {
    const control = this.control as AbstractControl | null;
    if (!control) {
      return;
    }
    if (this.disabled) {
      if (control.enabled) {
        control.disable({ emitEvent: false });
      }
    } else if (control.disabled) {
      control.enable({ emitEvent: false });
    }
  }

  get isVisuallyDisabled(): boolean {
    return this.disabled || !!this.control?.disabled;
  }

  onClick(event: MouseEvent) {
    this.sendClick.emit(event);
  }
}
